import { Divider, Stack } from '@mui/material'
import { useRef, useState } from 'react'
import ClientNotes from 'client/components/CandidateDrawer/ClientNotes'
import DrawerComponent from 'shared/components/DrawerComponent'
import RosterCandidateRecruiterNotes from './RosterCandidateRecruiterNotes'

type EditingNote = 'internal' | 'external' | null

interface CandidateRosterNoteDrawerProps {
    isOpen: boolean
    onClose: () => void
    onSave?: () => void
    rosterCandidateId: string
    canEdit: boolean
}

export const CandidateRosterNoteDrawer = ({
    isOpen,
    onClose,
    onSave,
    rosterCandidateId,
    canEdit,
}: CandidateRosterNoteDrawerProps) => {
    const [editingNote, setEditingNote] = useState<EditingNote>(null)
    const saveFnRef = useRef<(() => void) | null>(null)

    const handleClose = () => {
        setEditingNote(null)
        saveFnRef.current = null
        onClose()
    }

    const handleCancelEdit = () => {
        setEditingNote(null)
        saveFnRef.current = null
    }

    const handleSave = () => {
        saveFnRef.current?.()
    }

    return (
        <DrawerComponent
            open={isOpen}
            hasSaveButton={editingNote !== null}
            hasCancelButton={editingNote !== null}
            primaryActionText="Save"
            onPrimaryAction={handleSave}
            onCancel={handleCancelEdit}
            anchor="right"
            onClose={handleClose}
            headerTitle="Notes"
        >
            <Stack direction="column" spacing={3}>
                <RosterCandidateRecruiterNotes
                    isVisible={isOpen}
                    rosterCandidateId={rosterCandidateId}
                    onSave={onSave}
                    editingNote={editingNote}
                    onStartEdit={setEditingNote}
                    onCancelEdit={handleCancelEdit}
                    saveFnRef={saveFnRef}
                />
                <Divider />
                <ClientNotes
                    rosterCandidateId={rosterCandidateId}
                    allowDeleteOverride={canEdit}
                    allowNewNote={false}
                />
            </Stack>
        </DrawerComponent>
    )
}
